import { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { PathwayConfig } from '../../types';

/**
 * Service for pathway-related API calls
 */
export const pathwayService = {
  /**
   * Get pathways for a device
   * @param deviceId - The device ID
   */
  getPathways: (deviceId: string): Promise<AxiosResponse<PathwayConfig[]>> => {
    return apiClient.get(`/api/devices/${deviceId}/pathways`);
  },

  /**
   * Save a pathway
   * @param deviceId - The device ID
   * @param pathwayCode - The pathway code
   * @param pathway - The pathway data
   */
  savePathway: (
    deviceId: string,
    pathwayCode: string,
    pathway: PathwayConfig,
  ): Promise<AxiosResponse<void>> => {
    return apiClient.post(`/api/devices/${deviceId}/pathways/${pathwayCode}`, pathway);
  },
};
